import { createContext, useContext, useState, memo } from 'react';
import { getEmptyGuid } from '../Utils';
import { PeriodDay } from '../../types/PeriodDay';
import { TimeEntry, UserRegistrationPeriod } from '../../api/generated/data-contracts';
import { TimeGridMode } from '../../types/TimeGridMode';

export interface ICellContext {
    inputNodes: any;
    addInputNode: any;
    onCellUpdated: (
        time: UserRegistrationPeriod,
        day: PeriodDay,
        te: TimeEntry,
        value: number,
        comment: string,
        flagged: boolean,
        mode: TimeGridMode,
        prevVal: number,
        saveSuccess: Function,
        skipApiCall?: boolean,
    ) => Promise<void>;
}

interface IProps {
    onCellUpdated: (
        time: UserRegistrationPeriod,
        day: PeriodDay,
        te: TimeEntry,
        value: number,
        comment: string,
        flagged: boolean,
        mode: TimeGridMode,
        prevVal: number,
        saveSuccess: Function,
        skipApiCall?: boolean,
    ) => Promise<void>;
}

const CellContext = createContext<ICellContext | undefined>({
    inputNodes: [],
    addInputNode: () => null,
} as ICellContext);

export const useCellCtx = () => useContext(CellContext) as ICellContext;

export const CellContextProvider: React.FC<IProps> = memo(({ children, onCellUpdated }) => {
    const [inputNodes] = useState(() => new Map());
    //console.log(inputNodes)
    const addInputNode = (taskId: any, workTypeId: string, dayIndex: any, ref: any) => {
        const wtid = workTypeId == null || workTypeId == undefined ? getEmptyGuid() : workTypeId;
        inputNodes.set(`${taskId}_${wtid}_${dayIndex}`, ref);
    };

    return (
        <CellContext.Provider
            value={{
                inputNodes,
                addInputNode,
                onCellUpdated,
            }}
        >
            {children}
        </CellContext.Provider>
    );
});

export default CellContext;
